import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { sendEvent } from '@nubank/www-latam-commons/services/analytics';

import { CollapseContainer } from './styles/CollapseContainer';
import { CollapseHeader } from './patterns/CollapseHeader/CollapseHeader';
import { CollapseBody } from './patterns/CollapseBody/CollapseBody';

function Collapse({
  children,
  className,
  initiallyOpen,
  buttonId,
  contentId,
}) {
  const [isOpen, toggleButton] = useState(initiallyOpen);

  const handleToggleButton = useCallback(() => {
    if (!isOpen) {
      sendEvent('FAQ_OPEN_QUESTION', buttonId);
    }

    toggleButton(!isOpen);
  }, [isOpen]);

  return (
    <CollapseContainer className={className}>
      {
        React.Children.map(children, child => (
          React.cloneElement(child, {
            isOpen,
            handleToggleButton,
            buttonId,
            contentId,
          })
        ))
      }
    </CollapseContainer>
  );
}

Collapse.defaultProps = {
  className: undefined,
  initiallyOpen: false,
};

Collapse.propTypes = {
  buttonId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  contentId: PropTypes.string.isRequired,
  initiallyOpen: PropTypes.bool,
};

Collapse.Header = CollapseHeader;
Collapse.Body = CollapseBody;

export default Collapse;
